import {legacy_createStore as  createStore,applyMiddleware,compose } from 'redux';
import rootReducer from "./reducer/index";
import {thunk} from 'redux-thunk';
const store  = createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk),
        // process.env.NODE_ENV === "development" &&  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
    )
)

export default store;
